/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useUpdateUserAttributes
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

interface IParams {
	id: string;
	key: string;
	attributes: IColumnMeta[];
}

/**
 * Mutate for update user attributes
 */
const useUpdateUserAttributes = (): UseMutationResult<unknown, IAxiosError, IParams, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id, key, attributes }) => {
			if (id && key) {
				await api.KeycloakUserApi.patchUserAttributes({ id, requestBody: { [key]: [JSON.stringify(attributes)] } });
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.userAttributes] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateUserAttributes;
